export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '果仁科技',

    /** 公司名称 */
    name: '北京果仁科技有限公司',
    /** 公司微信 */
    wechat: '果仁科技',
    /** 公司邮箱 */
    email: 'info@smallnut.com',
    /** 公司手机 */
    phone: '138-1064-6504',
    /** 公司电话 */
    tel: '15810005819',
    /** 公司地址 */
    address: '北京市西城区西直门外大街宝蓝金融创新中心B厅',
    /** 备案号 */
    keepOnRecordIcp: '京ICP备2020040204号-1',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 116.34734,
        latitude: 39.944563,
        title: '宝蓝金融创新中心',
        address: '北京市西城区西直门外大街宝蓝金融创新中心B厅'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js